import React from "react";
import { BreadcrumbItem } from "reactstrap";
import { Route, Switch, Link } from "react-router-dom";
import * as HomeRoute from "./home";

// Read-only and single-page: the dashboard summarises what lives under /domain,
// so there is nothing here to create, edit or address individually — no `new`,
// no `:id` and no entity route.
//
// No Section.Provider either, unlike every other section in this app. That
// provider exists to bind a JSON Schema to a form and a mutation, and this
// screen has neither: the aggregates come back as JSON columns and are drawn by
// hand. Wrapping it in one would mean naming a schema that describes nothing on
// the page.
export function Content(props) {
  return (
    <Switch>
      <Route path={`/dashboard/`} component={HomeRoute.Content} />
    </Switch>
  );
}

export function Indice(props) {
  return (
    <>
      <BreadcrumbItem>
        <Link to={`/dashboard`}>Dashboard</Link>
      </BreadcrumbItem>
      <Switch>
        <Route path={`/dashboard/`} component={HomeRoute.Indice} />
      </Switch>
    </>
  );
}

export const Sidebar = () => <></>;
